var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPipelinelookup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.40874 0L1.32955 1.07919L1.3291 8.5L3.73725 10.2327H5.24206L5.4427 7.84402L5.24206 6.01925L3.91889 3.61155L5.67584 3.47771L5.4427 0.621989L5.24206 0H2.40874Z",
    fill: "#FFDF40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07453 0H5.24121L5.24121 3.47771L6.44506 3.77206L5.24121 6.01925V10.2327H8.07453L9.15372 9.15353V7.52406L8.95308 7.28329L9.15372 6.92213V6.32021L8.95308 6.01925L9.15372 5.71828V1.07919L8.07453 0Z",
    fill: "#FFBE40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.83398 4.4077C2.83398 5.73532 3.91406 6.8154 5.24168 6.8154L5.44232 5.91251L5.24168 5.31059V3.50483L5.64798 3.00822L5.24168 2C3.91406 2 2.83398 3.08007 2.83398 4.4077Z",
    fill: "#252525"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24121 2V6.8154C6.56882 6.8154 7.64891 5.73532 7.64891 4.4077C7.64891 3.08007 6.56882 2 5.24121 2Z",
    fill: "#464F75"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.70362 10.362L1.22732 9.86296L3.93704 5.57808L5.1085 6.21496L2.39884 10.4999L1.70362 10.362Z",
    fill: "#252525"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54199 7.82471H6.14392V9.02856H5.54199V7.82471Z",
    fill: "#FFBE40"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74707 7.82471H7.34899V9.02856H6.74707V7.82471Z",
    fill: "#FFBE40"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9502 5.71826H9.15404V6.32019H7.9502V5.71826Z",
    fill: "#37375C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9502 6.92188H9.15404V7.5238H7.9502V6.92188Z",
    fill: "#37375C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.24153 5.71206C4.52249 5.71206 3.9375 5.12708 3.9375 4.40803C3.9375 3.68899 4.52249 3.104 5.24153 3.104L5.24219 3.10696V3.104C5.96126 3.104 6.54622 3.68899 6.54622 4.40803C6.54622 5.12708 5.96126 5.71206 5.24219 5.71206V5.70911L5.24153 5.71206Z",
    fill: "#ECE6F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipelinelookup);
export default __webpack_public_path__ + "static/media/pipelinelookup.603f6121f5f2dbe7b919c484a81baf32.svg";
export { ForwardRef as ReactComponent };